import "./BakeryForm.css";

import BasicInfoSection from "./sections/BasicInfoSection/BasicInfoSection";
import PricingSection from "./sections/PricingSection/PricingSection";
import ProductOptionsSection from "./sections/ProductOptionsSection/ProductOptionsSection";
import AvailabilitySection from "./sections/AvailabilitySection/AvailabilitySection";
import ImageSection from "./sections/ImageSection/ImageSection";

function BakeryForm({
  formData,
  updateField,
}) {
  return (
    <div className="bakery-form">

      <BasicInfoSection
        formData={formData}
        updateField={updateField}
      />

      <PricingSection
        formData={formData}
        updateField={updateField}
      />

      <ProductOptionsSection
        formData={formData}
        updateField={updateField}
      />

      <AvailabilitySection
        formData={formData}
        updateField={updateField}
      />

      <ImageSection
        formData={formData}
        updateField={updateField}
      />

    </div>
  );
}

export default BakeryForm;